import { handleError } from 'utils/js/error_helpers'

const videoMiddle = store => next => action => {
    switch (action.type) {
        case 'PAUSE_PLAYERS': {
            let players = store.getState().nhlLivetracker.activeVideoPlayers

            try {
                for (let i = 0; i < players.length; i++) {
                    if (action.id && players[i] === action.id) continue

                    if (document.getElementById(players[i]).classList.contains('vjs-ad-playing')) {
                        // eslint-disable-next-line
                        videojs(players[i]).ima3.adsManager.stop()
                    } else {
                        // eslint-disable-next-line
                        videojs(players[i]).pause()
                    }
                }
            } catch (e) {
                handleError(e)
            }
            break
        }

        //This action is irrelevant to us, pass it on to the next middleware
        default:
            return next(action)
    }
}

export default videoMiddle
